import Admin from 'hive-admin';

import PageArchiveTable from '../../components/PageArchiveTable';

import {
  // ADMIN as FILTERS_ADMIN,
  COMPONENTS as FILTERS_COMPONENTS,
  BLOCKS as FILTERS_BLOCKS,
  LIBRARY as FILTERS_LIBRARY,
} from './filters';

import {
  // ADMIN as COLUMNS_ADMIN,
  COMPONENTS as COLUMNS_COMPONENTS,
  BLOCKS_ADMIN as COLUMNS_BLOCKS_ADMIN,
  BLOCKS_SELLER as COLUMNS_BLOCKS_SELLER,
  LIBRARY as COLUMNS_LIBRARY,
} from './columns';

import {
  COMPONENTS as FIELDS_COMPONENTS,
  BLOCKS as FIELDS_BLOCKS,
  LIBRARY as FIELDS_LIBRARY,
} from './fields';

import tests from '../../helpers/tests';

export default [
  ...[
    [
      'Components',
      'Component',
      'components',
      'COMPONENT',
      {
        filters: FILTERS_COMPONENTS,
        columns: COLUMNS_COMPONENTS,
        fields: FIELDS_COMPONENTS,
        skip: [tests.viewerIsNotThehiveRsAdmin],
        contentBuilderTargetable: true,
        contentBuilderTargetableRealm: 'ContentBuilderComponent:Field',
      },
    ], [
      'Library',
      'Library Item',
      'library',
      'LIBRARY_ITEM',
      {
        filters: FILTERS_LIBRARY,
        columns: COLUMNS_LIBRARY,
        fields: FIELDS_LIBRARY,
        skip: [tests.viewerIsNotAdmin],
        contentBuilderTargetable: true,
        contentBuilderTargetableRealm: 'ContentBuilderLibrary:Field',
      },
    ], [
      'Blocks',
      'Block',
      'blocks',
      'BLOCK',
      {
        filters: FILTERS_BLOCKS,
        columns: [],
        fields: FIELDS_BLOCKS,
        skip: [],
        getColumns: (props) => {
          if (!props.viewer) {
            return [];
          }
          return PageArchiveTable.defaultProps.getColumns(
            props,
            (
                props.viewer.role === 'ADMIN'
              ? COLUMNS_BLOCKS_ADMIN
              : COLUMNS_BLOCKS_SELLER
            ),
          );
        },
      },
    ],
  ].reduce(
    (
      agr,
      [
        title,
        titleSingle,
        path,
        type,
        {
          filters,
          columns,
          fields,
          skip,
          getColumns = PageArchiveTable.defaultProps.getColumns,
          contentBuilderTargetable = false,
          contentBuilderTargetableRealm,
        },
      ],
    ) => {
      agr.push(...Admin.compileFromLibrary(['GroupResource', {
        title,
        // icon: 'experiment',
        path: `/website/${path}`,
        archiveLoadUrl: '/contentbuilder/segments',
        singleLoadUrl: `/contentbuilder/segments/:id/?${[
          'resolveContent=true',
          'includeStoreData=true',
        ].join('&')}`,
        redirect: [['redirect.unauthorized']],
        headerTitleKey: 'name',
        filters,
        columns,
        fields,
        archiveConfig: {
          title,
          label: title,
          // icon: 'experiment',
          createButtonPath: `/website/${path}/create`,
          getColumns,
        },
        singleCreateUrl: `/contentbuilder/segments/${path}`,
        singleConfig: {
          hidden: true,
          alias: `/website/${path}`,
          headerTitle: `Create ${titleSingle}`,
          backButtonPaths: [`/website/${path}`],
          // eslint-disable-next-line max-len
          duplicateLoadUrl: '/contentbuilder/segments/:duplicate/?resolveContent=true',
          contentBuilderSegmentType: type,
          contentBuilderTargetable,
          contentBuilderTargetableRealm,
        },
        // singleCreateConfig: {
        // },
        singleEditConfig: {
          actions: [
            ['ActionSave'],
            ['ActionDelete'],
            ['Action', {
              name: 'duplicate',
              title: 'Duplicate',
              ghost: true,
              onClick: (props) => props.history.push(
                `/website/${path}/create?duplicate=${
                  props.data ? props.data._id : null
                }`
              ),
            }],
          ],
        },
        skip,
      }]).pages);
      return agr;
    },
    [],
  ),
];
